
import {Component, Vue} from 'vue-property-decorator';
import {getImageUrl} from 'src/utils/helpers';
import CatalogCard from '../components/cards/CatalogCard.vue';
import {analyticsController} from '../../user/analytics/AnalyticsController';
import {Notify} from 'quasar';

@Component({components: {CatalogCard}})
export default class BuySongModal extends Vue {
  getImageUrl = getImageUrl;
  awaitPayment = false;
  catalogEntry: any = null;
  source: string = null;
  isOpen: boolean = false;

  mounted() {
    this.$root.$on('buySongModal_open', this.openBuyModal);
  }

  beforeDestroy() {
    this.$root.$off('buySongModal_open');
  }

  buySong() {
    this.awaitPayment = true;
    setTimeout(() => (this.awaitPayment = false), 500);
    analyticsController.logBasicAnalyticsEvent('clicked on buy song button', 'Pay Per Song Events');
    Notify.create({
      message:
          "Merci pour votre intérêt ! Nous ne permettons pas encore l'achat mais nous avons noté votre intention et reviendrons vers vous très prochainement.",
      position: 'bottom',
    });
  }

  closeModal() {
    this.isOpen = false;
  }

  openBuyModal(songToBuyInfos) {
    this.catalogEntry = songToBuyInfos.catalogEntry;
    this.source = songToBuyInfos.source;
    this.isOpen = true;
  }
}
